<button
  [pTooltip]="tooltip()"
  [disabled]="disabled()"
  [class.bg-neutral-700]="highlighted()"
  (click)="action.emit()"
  class="group/shortcut w-full flex justify-center items-center hover:bg-neutral-700 px-6 py-2 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
  tooltipPosition="top"
>
  <flx-icon
    [name]="icon()"
    class="mr-3"
  />
  <span
    [innerHtml]="title()"
    class="flex-auto text-start text-neutral-100 text-sm/[22px]"
  ></span>
  @if (shortcut()) {
    <flx-ai-shortcut
      [label]="shortcut().label"
      [icons]="shortcut().icons"
    ></flx-ai-shortcut>
  }
</button>
